"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const i18n_js_1 = __importDefault(require("i18n-js"));
const StatusBox = styled_components_1.default.div `
  display: inline-flex;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.2);
  padding: ${props => 0.5 * props.size}vmin ${props => 1.5 * props.size}vmin;
  border-radius: ${props => 1 * props.size}vmin;
  margin-top: ${props => 1 * props.size}vmin;
  white-space: nowrap;
  transform: scale(${props => props.size});
  transform-origin: left top;
  width: fit-content;
  color: white;
`;
const StatusCircle = styled_components_1.default.div `
  width: ${props => 2 * props.size}vmin;
  height: ${props => 2 * props.size}vmin;
  border-radius: 50%;
  margin-right: ${props => 1 * props.size}vmin;
  background-color: ${props => {
    switch (props.state) {
        case 'available':
            return 'green';
        case 'few_places_left':
        case 'not_yet_bookable':
            return 'yellow';
        case 'disabled':
        case 'sold_out':
        case 'canceled':
        case 'not_bookable_anymore':
            return 'red';
        default:
            return 'green';
    }
}};
`;
const StatusText = (0, styled_components_1.default)(material_1.Typography) `
  font-size: ${props => 2.5 * props.size}vmin;
  color: inherit;
`;
const BookingStatus = ({ availabilityState, size, currentLocale }) => {
    (0, react_1.useEffect)(() => {
        if (currentLocale) {
            i18n_js_1.default.locale = currentLocale;
        }
    }, [currentLocale]);
    const getStatusText = (state) => {
        switch (state) {
            case 'canceled':
                return i18n_js_1.default.t('booking_status_cancelled');
            case 'sold_out':
                return i18n_js_1.default.t('mssngr.booking_states.sold_out');
            case 'not_yet_bookable':
                return i18n_js_1.default.t('booking_status_not_yet_bookable');
            case 'disabled':
                return i18n_js_1.default.t('booking_status_disabled');
            case 'not_bookable_anymore':
                return i18n_js_1.default.t('booking_status_not_bookable_anymore');
            case 'few_places_left':
                return i18n_js_1.default.t('booking_status_few_places_left');
            case 'available':
                return i18n_js_1.default.t('booking_status_available');
            default:
                return i18n_js_1.default.t('booking_status_available');
        }
    };
    return (react_1.default.createElement(StatusBox, { className: "status-box", size: size },
        react_1.default.createElement(StatusCircle, { state: availabilityState, size: size }),
        react_1.default.createElement(StatusText, { size: size }, getStatusText(availabilityState))));
};
exports.default = BookingStatus;
